import { z } from 'zod'

// 학부모 고유 ID(`P1221577`)는 자녀 학생 ID 의 I 를 P 로 바꾼 값이고, 로그인 ID(`P63729170`)는 P + 8자리다.
// 학생과 같이 접두 검사를 런타임에 두고 타입은 string 으로 둔다.
export const ParentIdSchema = z.string().regex(/^P/, '학부모 ID 는 P 로 시작한다')
export type ParentId = z.infer<typeof ParentIdSchema>
export const ParentLoginIdSchema = z.string().regex(/^P/, '학부모 로그인 ID 는 P 로 시작한다')

// 학생 응답이 싣는 보호자. 서버는 보호자가 없는 학생도 이 객체를 빼지 않고 네 필드를 빈 문자열로 채워 보낸다
// (StudentResponse.Parent 의 기본값). 그래서 ID 둘은 접두 검사 대신 빈 문자열도 받는다.
export const ParentSchema = z.object({
  id: ParentIdSchema.or(z.literal('')),
  loginId: ParentLoginIdSchema.or(z.literal('')),
  phone: z.string(),
  email: z.string(),
})
export type Parent = z.infer<typeof ParentSchema>

// 학부모 계정에 연결된 자녀. 서버는 학부모 정보·관계 목록도 함께 싣지만 앱은 자녀 id 만 읽어 받지 않는다.
// 학생 id 스키마는 Student 가 이 파일을 품어 참조하면 순환이 생기므로 문자열로 받는다.
export const ParentChildrenSchema = z.object({
  studentIds: z.array(z.string()),
})
export type ParentChildren = z.infer<typeof ParentChildrenSchema>
